import { UploadFileRounded } from '@mui/icons-material';
import { Button, ButtonProps, Input, InputLabel, Stack } from '@mui/material';
import { ChangeEvent } from 'react';

interface FileSelectProps {
  id: string;
  onFileSelect: (file: File) => void;
  acceptFileType: string;
  isLoading?: boolean;
  buttonProps?: Omit<ButtonProps, 'children'>;
  buttonLabel?: string;
}

export const FileSelect = ({
  id,
  onFileSelect,
  acceptFileType,
  isLoading = false,
  buttonProps,
  buttonLabel = 'Upload File',
}: FileSelectProps) => {
  const handleOnChange = (e: ChangeEvent<HTMLInputElement>) => {
    const files = e.target.files;
    if (!files) {
      return;
    }

    onFileSelect(files[0]);
    e.target.value = '';
  };

  return (
    <Stack spacing={1} width="100%">
      <InputLabel htmlFor={`file-select-${id}`}>
        <Input
          id={`file-select-${id}`}
          inputProps={{
            accept: acceptFileType,
          }}
          onChange={handleOnChange}
          type="file"
          hidden
        />
        <Button
          disabled={isLoading}
          variant="text"
          startIcon={<UploadFileRounded />}
          size="small"
          component="span"
          id="upload-btn"
          {...buttonProps}
        >
          {isLoading ? 'Loading' : buttonLabel}
        </Button>
      </InputLabel>
    </Stack>
  );
};
